import React, { useState } from "react";
import { Form as AppForm } from "MODULES/shared/components/Forms";
import Form from "MODULES/shared/components/DownloadPackingSlipModal/Form";
import { stringify } from "query-string";
import { SHIPPING_CHECKLIST } from "MODULES/shared/components/CommercialInvoice/helpers";

function DownloadPackingSlip({ record, url, setCurrentForm }) {
  const [lineItemIds, setLineItemIds] = useState(
    record.line_items.map(l => l.id)
  );

  if (record) {
    return [
      <AppForm.Body>
        <Form
          setLineItemIds={setLineItemIds}
          lineItemIds={lineItemIds}
          record={record}
          partKey="part.part_number"
          serialKey="serial_number"
        />
      </AppForm.Body>,
      <AppForm.Footer>
        <AppForm.Cancel
          close={() => setCurrentForm(SHIPPING_CHECKLIST)}
          editable
        />
        <AppForm.Submit
          text="Download"
          disabled={false}
          editable
          onClick={() => {
            window.open(
              `${url}&${stringify({
                line_item_ids: lineItemIds.join(",")
              })}`,
              "_blank"
            );
            setCurrentForm(SHIPPING_CHECKLIST);
          }}
        />
      </AppForm.Footer>
    ];
  }
}

export default DownloadPackingSlip;



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/DownloadPackingSlip/DownloadPackingSlip.jsx